import { render } from "./ReleaseStatusBadge.vue?vue&type=template&id=a2bddbe6"
import script from "./ReleaseStatusBadge.vue?vue&type=script&lang=ts"
export * from "./ReleaseStatusBadge.vue?vue&type=script&lang=ts"
script.render = render

export default script